/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractType } from './contractType.model';


export interface DocumentTemplate { 
    active?: boolean;
    combined?: boolean;
    contractType: ContractType;
    deletable?: boolean;
    fileAttachmentBinaryProdTemplateName?: string | null;
    fileAttachmentBinaryTestTemplateName?: string;
    fileAttachmentName: string;
    fileMainBinaryProdTemplateName?: string | null;
    fileMainBinaryTestTemplateName?: string;
    fileMainName: string;
    id?: number;
    name: string;
    signingEligibleAttachmentProd: boolean;
    signingEligibleAttachmentTest: boolean;
    signingEligibleMainProd: boolean;
    signingEligibleMainTest: boolean;
}
export namespace DocumentTemplate {
}


